import BaseApiRepository from './baseApiRepository'
import VehicleType from '../models/vehicleTypeModel'

export default class vehicleTypeRepository extends BaseApiRepository {

  getTypes (lang: string = 'en'): Promise<any> {
    return this.get('/security_vehicle_types', { headers: { 'Accept-Language': lang } }).then(function (result: any) {

      let types = []
      for (let index = 0; index < result['hydra:member'].length; index++) {

        types[index] = new VehicleType().set(result['hydra:member'][index])
      }

      return types
    })
  }

}
